import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-f2207e1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "text-h5"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Beta")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Popular")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Today")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Today")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Favorites")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Submit")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Login/Sign Up")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Popular")
const _hoisted_11 = {
  key: 0,
  class: "username-container"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("View/Edit Your Info")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Governing Type of NFT You're Working As.")
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "username-container"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("View/Edit Your Info")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("  |  ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Governing Type of NFT You're Working As.")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Click for more info.")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Click on current role for more info.")
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" PrjctHunt Roles: ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Explorer")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" This is the default role on PrjctHunt. No frills. Everyone gets this role for signing up. ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Founder")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" This is the highest role on PrjctHunt. Attained by holding one or more PrjctPhoenix: Founder NFT in the connected wallet. ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, " Perks include: "),
  /*#__PURE__*/_createElementVNode("dd", null, "⭐ All perks of PrjctPhoenix Member"),
  /*#__PURE__*/_createElementVNode("dd", null, "⭐ Top priority on Feature requests"),
  /*#__PURE__*/_createElementVNode("dd", null, " ... and more. ")
], -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Member")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" This is the second highest role on PrjctHunt.Attained by holding one or more PrjctPhoenix: Member Collection NFT in the connected wallet. ")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, " Perks include: "),
  /*#__PURE__*/_createElementVNode("dd", null, " ⭐ Augmented Sponsoring when submitting Prjcts "),
  /*#__PURE__*/_createElementVNode("dd", null, " ⭐ Full access to all features Available ")
], -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Affiliate")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" This is the second level membership role on PrjctHunt. Attained by holding one or more of any PrjctPhoenix Affiliate's NFT in the connected wallet. ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Saved")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" This is the base level membership role on PrjctHunt. Attained by holding one or more PrjctPhoenix: Saved By Fire in the connected wallet. ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Holder : ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Navigate to Search Page")
const _hoisted_43 = {
  key: 0,
  class: "text-subtitle text-white"
}
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Connect a Wallet with Prjct Phoenix NFT To Use This Feature. ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Have one?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("a", { href: "#/login" }, "LOGIN")
], -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "text-subtitle text-white"
}
const _hoisted_48 = { class: "button-container" }
const _hoisted_49 = {
  key: 2,
  class: "workAs text-h6"
}
const _hoisted_50 = { class: "drawer-wrapper" }
const _hoisted_51 = { class: "wag-btn--container" }
const _hoisted_52 = {
  key: 0,
  class: "drawer"
}

import router from '@/router';
import { ref, watchEffect, computed, ComputedRef } from 'vue';
import Auth from '@/utils/auth';
import store, { ACTING_AS, State } from '@/store';
import { WalletMultiButton, useWallet } from 'solana-wallets-vue'
import { verifyNFT } from '@/utils/verifyNFT';
import { loginReminder } from '@/utils/helpers';
import { signout } from '@/utils/auth_func';
import LotteryButton from '@/components/LotteryButton.vue';
import { requestOptions, server } from '@/utils/helpers';
import useQuasar from 'quasar/src/composables/use-quasar.js';;


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNav',
  setup(__props) {

const verified = ref(false)
const lotteryView = ref(false)
const $q = useQuasar();
const wallet = useWallet()
const user = computed(() => store.state.user)
const holderStatus = ref(false)
const connected = computed(() => store.state.connected)
const rightDrawerOpen = ref(false)
// const searchToolbar = ref(false);
function toggleRightDrawer() {
    rightDrawerOpen.value = !rightDrawerOpen.value
    return
}
const authLevelInfo = ref(false)
const appTitle = "Prjct Hunt"
const nftMeta: ComputedRef<State["user"]["tokens"]> = computed(() => store.state.user.tokens)
const username = computed(() => store.state.user.username)
const defaultInfo = {
    token_id: `G-${user.value.id}`, img_src: `https://avatars.dicebear.com/api/identicon/${user.value.username}.svg`, token_name: `Explorer-${user.value.username}`, gov_weight: 0, gov_type: `Explorer`
}




function handleSignout() {
    verified.value = false
    return signout()
}

function login() {
    router.push('/login')
    return
}

function handleSelect(info: ACTING_AS) {
    if (store.state.actingAs == info) {
        // console.log('Samesies')
        return
    }
    console.log(info)
    store.commit('setAuthLevel', info.gov_type)
    store.commit('setActingAs', info)
    rightDrawerOpen.value = false;
    return

}
watchEffect(async () => {
    if (connected.value && Auth.loggedIn() && window.location.pathname === '/login') {
        router.push({ name: 'Popular' })
    }
    if (!store.state.user.wallet && wallet.publicKey.value) {
        store.commit('setWallet', wallet.publicKey.value.toBase58())
    }
    if (wallet.connected.value && !verified.value && store.state.actingAs.gov_type === 'Explorer') {
        const success = await verifyNFT(wallet.publicKey.value)
        if (success) {
            const result = await fetch(`${server()}token/send`, requestOptions({ walletString: wallet.publicKey.value, task: 'verifyNFT' }))
            const res = await result.json()
            if (result.status === 200) {
                $q.notify({
                    // type: 'success',
                    icon: 'grade',
                    color: 'secondary',
                    message: '$FIRE Earned',
                    caption: res.message,
                    position: 'top',
                    timeout: 10000
                })
            } else {
                console.log(res.message)
            }
            verified.value = true
        }
        if (!wallet.connected.value) {
            await store.dispatch('updateNFTMeta', [])
            verified.value = false;
            holderStatus.value = false;
        }

        if (nftMeta.value.length) {
            store.commit('setHolder', true)
            holderStatus.value = true;
        }
    }
})




return (_ctx: any,_cache: any) => {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, {
      elevated: "",
      class: "header bg-primary text-white",
      "height-hint": "98"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, {
          app: "",
          dark: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  ripple: "",
                  flat: "",
                  dark: "",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_avatar, { class: "white-shadow" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_avatar, null, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_unref($q).screen.gt.sm)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(appTitle)))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_chip, {
                  outline: "",
                  size: "sm",
                  dark: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!_unref($q).screen.gt.sm)
              ? (_openBlock(), _createBlock(_unref(WalletMultiButton), {
                  key: 0,
                  dark: ""
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_btn, {
              align: "right",
              dense: "",
              flat: "",
              round: "",
              icon: "menu",
              onClick: toggleRightDrawer
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_toolbar, { id: "tabs" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tabs, {
              align: !_unref($q).screen.gt.sm ? 'left' : 'center'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_route_tab, {
                  icon: "workspace_premium",
                  to: "/",
                  flat: "",
                  class: "hidden-sm-and-down",
                  label: _unref($q).screen.gt.sm ? 'Popular' : void 0
                }, {
                  default: _withCtx(() => [
                    (!_unref($q).screen.gt.sm)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          anchor: "top middle"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_q_route_tab, {
                  icon: "today",
                  to: "/today",
                  label: _unref($q).screen.gt.sm ? 'Today' : void 0
                }, {
                  default: _withCtx(() => [
                    (!_unref($q).screen.gt.sm)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          anchor: "top middle"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_q_route_tab, {
                  icon: "history",
                  to: "/previous",
                  label: _unref($q).screen.gt.sm ? 'Previous' : void 0
                }, {
                  default: _withCtx(() => [
                    (!_unref($q).screen.gt.sm)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          anchor: "top middle"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]),
                (_unref(connected))
                  ? (_openBlock(), _createBlock(_component_q_route_tab, {
                      key: 0,
                      icon: "grade",
                      to: "/favorites",
                      flat: "",
                      class: "hidden-sm-and-down",
                      label: _unref($q).screen.gt.sm ? 'Favorites' : void 0
                    }, {
                      default: _withCtx(() => [
                        (!_unref($q).screen.gt.sm)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              anchor: "top middle"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (_unref(connected))
                  ? (_openBlock(), _createBlock(_component_q_route_tab, {
                      key: 1,
                      icon: "send",
                      to: "Submit",
                      label: _unref($q).screen.gt.sm ? 'Submit' : void 0
                    }, {
                      default: _withCtx(() => [
                        (!_unref($q).screen.gt.sm)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              anchor: "top middle"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_separator, {
                  dark: "",
                  class: "hidden-sm-and-down"
                }),
                (!_unref(connected))
                  ? (_openBlock(), _createBlock(_component_q_route_tab, {
                      key: 2,
                      icon: "login",
                      flat: "",
                      class: _normalizeClass([_unref(loginReminder) ? 'highlight' : null, "hidden-sm-and-down"]),
                      onClick: login,
                      label: _unref($q).screen.gt.sm ? 'Login / Sign Up' : void 0
                    }, {
                      default: _withCtx(() => [
                        (!_unref($q).screen.gt.sm)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              anchor: "top middle"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["class", "label"]))
                  : _createCommentVNode("", true),
                (_unref(connected))
                  ? (_openBlock(), _createBlock(_component_q_route_tab, {
                      key: 3,
                      icon: "logout",
                      flat: "",
                      class: "hidden-sm-and-down",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSignout())),
                      label: _unref($q).screen.gt.sm ? 'Sign Out' : void 0
                    }, {
                      default: _withCtx(() => [
                        (!_unref($q).screen.gt.sm)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              anchor: "top middle"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["align"]),
            (_unref($q).screen.gt.sm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_unref(username))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createVNode(_component_q_btn, {
                          dense: "",
                          flat: "",
                          to: "/me",
                          disable: !_unref(username)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_avatar, {
                              square: "",
                              size: "sm"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: _unref(store).state.actingAs.img_src
                                }, null, 8, _hoisted_13)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, "    |  " + _toDisplayString(_unref(username)), 1),
                            _createVNode(_component_q_tooltip, { anchor: "bottom left" }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"]),
                        _createVNode(_component_q_btn, {
                          dense: "",
                          flat: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (authLevelInfo.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("  |  " + _toDisplayString(_unref(store).state.actingAs.gov_type) + " ", 1),
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, " Not Signed In "))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_q_toolbar, { class: "bg-primary search-toolbar text-white" }, {
          default: _withCtx(() => [
            (!_unref($q).screen.gt.sm)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  (_unref(username))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createVNode(_component_q_btn, {
                          dense: "",
                          flat: "",
                          to: "/me",
                          disable: !_unref(username)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_avatar, {
                              square: "",
                              size: "sm"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: _unref(store).state.actingAs.img_src
                                }, null, 8, _hoisted_19)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_tooltip, { anchor: "bottom left" }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disable"]),
                        _hoisted_21,
                        _createVNode(_component_q_btn, {
                          dense: "",
                          flat: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (authLevelInfo.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(store).state.actingAs.gov_type) + " ", 1),
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [
                                _hoisted_22,
                                _hoisted_23,
                                _hoisted_24
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_icon, { name: "o_info" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, " Not Signed In "))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_q_dialog, {
          class: "auth-level-info",
          modelValue: authLevelInfo.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((authLevelInfo).value = $event)),
          "transition-show": "slide-up",
          "transition-hide": "slide-down"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, { dark: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_bar, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      dense: "",
                      flat: "",
                      icon: "close"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { class: "bg-white text-primary" }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "roles-page-title text-h5" }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "roles-container" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, {
                      dark: "",
                      class: "shadow-up-10 shadow-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "role-title" }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, { class: "role-description" }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_card, {
                      dark: "",
                      class: "shadow-up-10 shadow-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "role-title" }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, { class: "role-description" }, {
                          default: _withCtx(() => [
                            _hoisted_32,
                            _hoisted_33
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_card, {
                      dark: "",
                      class: "shadow-up-10 shadow-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "role-title" }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, { class: "role-description" }, {
                          default: _withCtx(() => [
                            _hoisted_35,
                            _hoisted_36
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_card, {
                      dark: "",
                      class: "shadow-up-10 shadow-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "role-title" }, {
                          default: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, { class: "role-description" }, {
                          default: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_card, {
                      dark: "",
                      class: "shadow-up-10 shadow-12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "role-title" }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_section, { class: "role-description" }, {
                          default: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_q_drawer, {
      dark: "",
      modelValue: rightDrawerOpen.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rightDrawerOpen).value = $event)),
      side: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_unref($q).screen.gt.sm)
            ? (_openBlock(), _createBlock(_unref(WalletMultiButton), {
                key: 0,
                dark: ""
              }))
            : _createCommentVNode("", true),
          _hoisted_41,
          _createElementVNode("span", {
            class: _normalizeClass(holderStatus.value ? 'holder' : 'no-holder')
          }, _toDisplayString(holderStatus.value), 3)
        ]),
        _createVNode(_component_q_btn, {
          id: "search-btn",
          color: "accent",
          fab: "",
          icon: "search",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/search')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!verified.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
          : (_openBlock(), _createElementBlock("div", _hoisted_47, "Select an NFT for use. ")),
        _createVNode(_component_q_separator, {
          dark: "",
          spaced: ""
        }),
        _createElementVNode("div", _hoisted_48, [
          (_unref(connected))
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                class: "drawer-btn",
                fit: "",
                fab: "",
                label: "View Your Favorite Prjcts",
                to: "/favorites"
              }))
            : _createCommentVNode("", true),
          (_unref(connected))
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 1,
                class: "drawer-btn",
                fit: "",
                fab: "",
                label: "Submit Prjct",
                to: "/submit"
              }))
            : _createCommentVNode("", true),
          (_unref(connected))
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 2,
                class: "drawer-btn",
                fit: "",
                fab: "",
                label: "Edit Profile",
                to: "/me"
              }))
            : _createCommentVNode("", true),
          (_unref(connected))
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 3,
                class: "drawer-btn",
                fit: "",
                fab: "",
                label: "Bug / Feature Request",
                to: "/report"
              }))
            : _createCommentVNode("", true),
          (_unref(connected) && _unref(wallet).connected.value)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 4,
                class: "drawer-btn",
                color: "$accent",
                fit: "",
                fab: "",
                label: "$Fire Lottery",
                onClick: _cache[5] || (_cache[5] = () => lotteryView.value = !lotteryView.value)
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_q_separator, {
          dark: "",
          spaced: ""
        }),
        (_unref(nftMeta).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, " Work As "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            (_unref(nftMeta).length)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  fab: "",
                  ripple: "",
                  clickable: "",
                  class: "wag-btn",
                  label: "Guest",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (handleSelect({ ...defaultInfo })))
                }))
              : (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  class: "wag-btn",
                  fab: "",
                  dark: "",
                  disabled: "",
                  label: "Get One from MagicEden",
                  target: "_blank"
                }))
          ]),
          (_unref(nftMeta))
            ? (_openBlock(), _createElementBlock("section", _hoisted_52, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nftMeta), (nft) => {
                  return (_openBlock(), _createBlock(_component_q_card, {
                    class: "nft-card",
                    key: nft.key,
                    dark: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, {
                        type: "button",
                        ripple: "",
                        class: "select-btn",
                        onClick: () => handleSelect({ token_id: nft.mint, img_src: nft.image, token_name: nft.name, gov_weight: nft.gov_weight, gov_type: nft.gov_type })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_img, {
                            src: nft.image,
                            ratio: "1"
                          }, null, 8, ["src"]),
                          _createVNode(_component_q_card_actions, {
                            align: "center",
                            class: "truncate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(nft.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      class: "auth-level-info",
      modelValue: lotteryView.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((lotteryView).value = $event)),
      "transition-show": "slide-up",
      "transition-hide": "slide-down"
    }, {
      default: _withCtx(() => [
        _createVNode(LotteryButton)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})